var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags.length)?_c('div',{staticClass:"container-tags"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,staticClass:"tag"},[_c('span',[_vm._v(_vm._s(tag.name))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }